
import React from 'react';
import { Button } from '@/components/ui/button';

interface BusinessDetailsHeaderProps {
  handleBack: () => void;
  handleSave: () => void;
  title?: string;
  formChanged?: boolean;
  showButtons?: boolean;
}

export const BusinessDetailsHeader: React.FC<BusinessDetailsHeaderProps> = ({
  handleBack,
  handleSave,
  title = "Edit Business Details",
  formChanged = true,
  showButtons = true
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-semibold">{title}</h1>
      {formChanged && showButtons && (
        <div className="flex gap-2">
          <Button variant="outline" onClick={handleBack}>
            Cancel
          </Button>
          <Button onClick={handleSave}>
            Save Changes
          </Button>
        </div>
      )}
    </div>
  );
};
